import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { listadoCalles } from '../../utils/Datos';

const options = [
  { value: 'calle 1', label: 'Calle 1' },
  { value: 'opcion2', label: 'Opción 2' },
  { value: 'Cartagena', label: 'Cartagena' },
  // Agrega más opciones aquí
];



export const Calles = ({
    className,
    updateState,
    val
    }) => {

    const [valor, setvalor] = useState({value:val,label:val})

    const [opciones, setopciones] = useState([]);
    useEffect(() => {
      listadoCalles().then((calles)=>{
        if (calles.status) {
            const {datos}=calles;
            let listado_temporal=[];
            datos.map((element,index)=>{
                listado_temporal.push({value:element.street,label:element.street});
            });
            setopciones(listado_temporal);
            setvalor({value:val,label:val});
        }
        
      })
    }, [])
    

    useEffect(() => {
      setvalor({value:val,label:val})
    }, [val])
    

    const handleChange = ((e)=>{
        console.log(e);
        setvalor(e);
        updateState([
            {
              name: "calle",
              value: e.value,
            },
        ])
    })

    return (
        <Select 
            classNamePrefix="select"
            name='calle'
            value={valor}
            onChange={handleChange}
            className={className} 
            options={opciones} />
    );
}
